<template>
  <v-server-table
      class="sync-managemend-report-table clearfix"
      :url="`/api?entity=vessel&action=getSyncContacts&sync_id=${syncId}&state=${label}`"
      :columns="columns"
      :options="options"
      v-cloak>
    <span slot="afterFilter">
        <slot name="afterFilter" />
    </span>
  </v-server-table>
</template>

<script>
import {ServerTable} from 'vue-tables-2';

export default {
  name: 'sync-management-report-table',
  components: {ServerTable},

  props: {
    label: {
      type: String,
      required: true,
    },
    syncId: {
      type: Number,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    headings: {
      type: Array,
      required: true,
    },
    sortable: {
      type: Array,
      required: true,
    },
  },
  computed: {
    options() {
      return {
        texts: {
          filterPlaceholder: 'Search',
          count: '{count} ' + 'Contacts',
        },
        sortable: this.sortable,
        debounce: 1000,
        headings: this.getHeadings,
        perPageValues: [10, 25, 50, 100],
        responseAdapter(response) {
          const {data, meta} = (response && response.data) || {};

          return {
            data: data || [],
            count: (meta && meta.total_count) || 0
          };
        },
      };
    },
    getHeadings() {
      let headings = {};
      this.columns.map((key, i) => (headings[key] = this.headings[i]));
      return headings;
    },
  },
};
</script>


<style lang="scss">
.sync-managemend-report-table {
  .VueTables__search {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
